import { IconProps } from "./types";

export const PackageIcon = ({
  size = 18,
  color = "currentColor",
  className,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={0.2}
      d="M16.75 5.784c0 .45-.242.858-.625 1.066l-1.45.784-1.233.658-2.559 1.383c-.275.15-.575.225-.883.225s-.608-.075-.883-.225L3.875 6.85a1.21 1.21 0 0 1-.625-1.066c0-.45.242-.859.625-1.067l1.642-.883 1.308-.709 2.292-1.233c.55-.3 1.216-.3 1.766 0l5.242 2.825c.383.208.625.617.625 1.067m-8.501 4.874L3.374 8.216a1.19 1.19 0 0 0-1.167.05c-.358.217-.566.6-.566 1.017v4.608c0 .8.441 1.517 1.158 1.875L7.674 18.2c.167.083.35.125.533.125.217 0 .434-.059.625-.184.359-.216.567-.6.567-1.016v-4.609a2.05 2.05 0 0 0-1.15-1.858"
      fill={color}
    />
    <path
      opacity={0.8}
      d="M18.36 9.292V13.9c0 .792-.441 1.508-1.158 1.867l-4.875 2.441a1.19 1.19 0 0 1-1.167-.058c-.35-.217-.566-.6-.566-1.017v-4.6c0-.8.441-1.516 1.158-1.875l1.792-.891 1.25-.625 1.833-.917a1.17 1.17 0 0 1 1.167.05c.35.217.566.6.566 1.017"
      fill={color}
    />
  </svg>
);
